import React from "react";
// Inline SVG language icons — no image files needed

export const EnglishIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* UK Flag */}
    <rect width="36" height="36" rx="18" fill="#012169"/>
    {/* White diagonals */}
    <line x1="0" y1="0" x2="36" y2="36" stroke="white" strokeWidth="5"/>
    <line x1="36" y1="0" x2="0" y2="36" stroke="white" strokeWidth="5"/>
    {/* Red diagonals */}
    <line x1="0" y1="0" x2="36" y2="36" stroke="#C8102E" strokeWidth="3"/>
    <line x1="36" y1="0" x2="0" y2="36" stroke="#C8102E" strokeWidth="3"/>
    {/* White cross */}
    <rect x="14" y="0" width="8" height="36" fill="white"/>
    <rect x="0" y="14" width="36" height="8" fill="white"/>
    {/* Red cross */}
    <rect x="15.5" y="0" width="5" height="36" fill="#C8102E"/>
    <rect x="0" y="15.5" width="36" height="5" fill="#C8102E"/>
    {/* Clip to circle */}
    <rect width="36" height="36" rx="18" fill="transparent" style={{pointerEvents:'none'}}/>
  </svg>
);

export const HindiIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* India flag — tricolor + Ashoka Chakra */}
    <clipPath id="circleHi">
      <circle cx="18" cy="18" r="18"/>
    </clipPath>
    <g clipPath="url(#circleHi)">
      <rect width="36" height="12" fill="#FF9933"/>
      <rect y="12" width="36" height="12" fill="#FFFFFF"/>
      <rect y="24" width="36" height="12" fill="#138808"/>
      {/* Ashoka Chakra */}
      <circle cx="18" cy="18" r="4.5" fill="none" stroke="#000080" strokeWidth="1"/>
      <circle cx="18" cy="18" r="0.8" fill="#000080"/>
      {[0,15,30,45,60,75,90,105,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345].map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const x1 = 18 + 0.8 * Math.cos(rad);
        const y1 = 18 + 0.8 * Math.sin(rad);
        const x2 = 18 + 4.5 * Math.cos(rad);
        const y2 = 18 + 4.5 * Math.sin(rad);
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#000080" strokeWidth="0.5"/>;
      })}
    </g>
  </svg>
);

export const TeluguIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Same India flag for Telugu (Telangana state flag colors as accent) */}
    <clipPath id="circleTE">
      <circle cx="18" cy="18" r="18"/>
    </clipPath>
    <g clipPath="url(#circleTE)">
      <rect width="36" height="12" fill="#FF9933"/>
      <rect y="12" width="36" height="12" fill="#FFFFFF"/>
      <rect y="24" width="36" height="12" fill="#138808"/>
      {/* Ashoka Chakra */}
      <circle cx="18" cy="18" r="4.5" fill="none" stroke="#000080" strokeWidth="1"/>
      <circle cx="18" cy="18" r="0.8" fill="#000080"/>
      {[0,15,30,45,60,75,90,105,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345].map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const x1 = 18 + 0.8 * Math.cos(rad);
        const y1 = 18 + 0.8 * Math.sin(rad);
        const x2 = 18 + 4.5 * Math.cos(rad);
        const y2 = 18 + 4.5 * Math.sin(rad);
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#000080" strokeWidth="0.5"/>;
      })}
      {/* Telangana pink dot overlay on bottom strip */}
      <rect y="24" width="36" height="12" fill="#E91E8C" opacity="0.25"/>
    </g>
  </svg>
);



export const MenopauseIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="10" r="5" stroke="currentColor" strokeWidth="2" />
    <line x1="12" y1="15" x2="12" y2="22" stroke="currentColor" strokeWidth="2" />
    <line x1="9" y1="19" x2="15" y2="19" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const PCOSIcon =  ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="12" rx="8" ry="6" stroke="currentColor" strokeWidth="2" />
    <circle cx="9" cy="12" r="1.5" fill="currentColor" />
    <circle cx="15" cy="12" r="1.5" fill="currentColor" />
  </svg>
);

export const AutoimmuneIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3C8 3 5 6 5 10c0 5 7 11 7 11s7-6 7-11c0-4-3-7-7-7z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const InflammationIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2C10 5 14 6 12 9c-2 3-5 4-5 7a5 5 0 0010 0c0-3-3-4-5-7z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
